import { SOCIETY_SETTING_TYPE } from '@/constants/societySettings';
import type { Society } from '@/publicSearch/store/usePublicSearchContext';
import { OperatorOption } from '../constants';

/** Plain animal text uses the society default; explicit operators remain unchanged. */
export function resolveAnimalQuickSearchDefaultOperator(
  settings: Society['settings'],
): string {
  const value = settings?.find(
    (setting) =>
      setting.societySettingType ===
      SOCIETY_SETTING_TYPE.ANIMAL_QUICK_SEARCH_DEFAULT_OPERATOR,
  )?.value;
  return value?.trim().toLowerCase() === 'contains'
    ? OperatorOption.contains.value
    : OperatorOption.startsWith.value;
}
